module.exports = __webpack_public_path__ + "img/P65-en.1fad2abb.png";